import React from "react";
import Intro from "../intro";
import "./layout.scss";

const Layout = ({ children }) => {
  return <div className="w-container">{children}</div>;
};

export default Layout;
